import { ComboBox, DatePicker, DayOfWeek, DefaultButton, defaultDatePickerStrings, Dialog, DialogFooter, DialogType, Dropdown, Icon, IconButton, IDropdownOption, IPersonaProps, IPickerItemProps, IStackTokens, ISuggestionItemProps, ISuggestionModel, ISuggestionsProps, ITag, Label, MessageBar, MessageBarType, Modal, NormalPeoplePicker, PeoplePickerItem, Persona, PersonaSize, Pivot, PivotItem, PrimaryButton, Separator, Spinner, SpinnerSize, Stack, TagItemSuggestion, TagPicker, Text, TextField, Toggle, TooltipHost, ValidationState, values } from "@fluentui/react";
import { useId, useBoolean } from '@fluentui/react-hooks';
import { Field, FieldArray, FieldProps, Form, Formik } from "formik";
import { FormEventHandler, useEffect, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { useAppDispatch, useAppSelector } from "../../../../app/Hooks";
import * as Yup from 'yup';
import { DynamicInputField, InputField } from "../../controls/Controls";
import { inputs } from "../../../../app/Validation";
import { ClientReadableStream, RpcError, Status } from "grpc-web";
import { PayloadAction } from "@reduxjs/toolkit";
import { ApiMessage, APIRequest, clearSession, getHeaders, getSession, saveSession } from "../../../../app/Api";
import { Message } from "../../../common/Message/Message";
import { useNavigate, useSearchParams } from "react-router-dom";
import { BaseFormProps, FormType, InputFormProps } from "../../FormProps";
import { BoolValue, Int32Value, StringValue } from "google-protobuf/google/protobuf/wrappers_pb";
import { SessionExpiredDialog } from "../../../common/SessionExpiredDialog/SessionExpiredDialog";
import { formatDate, timestampToDate, toFixedWithoutRounding } from "../../../../app/Helpers";
import { AuthenticateReply } from "../../../../repository/UserManagement/authentication_pb";
import { TableState } from "../../../common/Table/TableSate";
import { AccountStatus, IdentityConformationState, LimitationType, Operations, OrderAction } from "../../../../app/Enums";
import { CurrenciesPage } from "../../../pages/Accountant/Currencies/CurrenciesPage";
import { GetCategoriesRequest } from "../../../../repository/Trading/category_pb";
import moment from "moment";
import { UsersPage } from "../../../pages/Customers/Users/UsersPage";
import { GetUsersRequest, NotifyRequest, NotifyResponse } from "../../../../repository/UserManagement/Customers/user_pb";
import { dismissMessage, getRoles, getUserTypes, reset, resetMessage, resetRoles, resetUserTypes, setIsFilteredRolesSet, setIsFilteredUserTypesSet, setSelectedRole, setMessage, setSelectedUserType, add } from "./NotifyFormSlice";
import { Timestamp } from "google-protobuf/google/protobuf/timestamp_pb";
import { GetUserTypesRequest } from "../../../../repository/UserManagement/Customers/usertype_pb";
import { GetRolesRequest } from "../../../../repository/UserManagement/Customers/role_pb";
import { UserTypesPage } from "../../../pages/Customers/UserTypes/UserTypesPage";
import { Popup } from "../../../common/Popup/Popup";
import { RolesPage } from "../../../pages/Customers/Roles/RolesPage";
import { List } from "../../../common/List/List";

let req: NotifyRequest;
let roleReq: GetRolesRequest;
let userTypeReq: GetUserTypesRequest;

let promise: any;
let getFilterPromise: any;
let org: number = -1;
let current: AuthenticateReply.AsObject;

export const NotifyForm: React.FunctionComponent<BaseFormProps & IStackTokens & InputFormProps> = (props) => {
    const { t, i18n } = useTranslation();
    const dispatch = useAppDispatch()
    const navigate = useNavigate();
    const [showTooltip, setShowTooltip] = useState(false);
    const tooltipId = useId('tooltipId');
    const [searchParams] = useSearchParams();
    const [currentAction, setCurrenctAction] = useState(0)
    const [selectedKey, setSelectedKey] = useState(0);
    const onNextClick = () => {
        setSelectedKey((selectedKey + 1) % 2);
    };
    const onBackClick = () => {
        setSelectedKey((selectedKey - 1) % 2);
    };
    const modalPropsStyles = { main: { maxWidth: 450 } };
    const [isDraggable, { toggle: toggleIsDraggable }] = useBoolean(false);
    const modalProps = useMemo(
        () => ({
            isBlocking: true,
            styles: modalPropsStyles,
            dragOptions: undefined,
        }),
        [isDraggable],
    );
    const [hideDialog, { toggle: toggleHideDialog }] = useBoolean(true);
    const [showConfirmation, setShowConfirmation] = useState({
        type: DialogType.normal,
        title: '',
        subText: '',
    });

    const state: {
        isLoading: boolean, message: ApiMessage | undefined, stage1: any,
        roles: TableState,
        userTypes: TableState
    } = useAppSelector((state) => {

        return {
            isLoading: state.notifyForm.isLoading, message: state.notifyForm.message, stage1: state.notifyForm.stage1,
            roles: state.notifyForm.roles,
            userTypes: state.notifyForm.userTypes


        }
    })
    const fromDate = new Date();
    fromDate.setDate(fromDate.getDate() - 365);

    useEffect(() => {
        var l = searchParams.get('org');
        req = new NotifyRequest()
        roleReq = new GetRolesRequest();
        userTypeReq = new GetUserTypesRequest();
        if (l) {
            org = Number(l);
            if (Number.isNaN(org)) {
                org = -1;
            } else {
                const wrapper = new Int32Value();
                wrapper.setValue(org);
                req.setOrganization(wrapper)
                roleReq.setOrganization(wrapper)
                userTypeReq.setOrganization(wrapper)

            }
        }
        const boolv = new BoolValue();
        boolv.setValue(true);
        const stat = new Int32Value();
        stat.setValue(AccountStatus.ACTIVE);

        roleReq.setNumofresults(state.roles.numberOfResults)
        roleReq.setOrder(state.roles.isDescending)

        userTypeReq.setNumofresults(state.userTypes.numberOfResults)
        userTypeReq.setOrder(state.userTypes.isDescending)

        if (props?.renderObject?.client) {
            const id = new StringValue();
            id.setValue(props?.renderObject?.client?.internalId);
            req.setId(id)
        } else {
        }

        current = getSession();
        if (!current) {
            clearSession();
            navigate("/login");
        }
        return () => { //clean up
            promise?.abort();
            getFilterPromise?.abort();
            dispatch(reset());
        }
    }, [])

    const onRoleFilterChanged = (filterText: string, selectedItems?: ITag[]): ITag[] => {

        dispatch(resetRoles())
        const wrapper = new StringValue();
        wrapper.setValue(filterText);
        roleReq.setSearch(wrapper)
        roleReq.setNextto(0)
        dispatch(setIsFilteredRolesSet(false))
        getFilterPromise?.abort();
        getFilterPromise = dispatch(getRoles({ body: roleReq, headers: getHeaders() }))

        return [];

    }
    const onUserTypeFilterChanged = (filterText: string, selectedItems?: ITag[]): ITag[] => {
        dispatch(resetUserTypes())
        const wrapper = new StringValue();
        wrapper.setValue(filterText);
        userTypeReq.setSearch(wrapper)
        userTypeReq.setNextto(0)
        dispatch(setIsFilteredUserTypesSet(false))
        getFilterPromise?.abort();
        getFilterPromise = dispatch(getUserTypes({ body: userTypeReq, headers: getHeaders() }))

        return [];
    }


    return (
        <>
            <Popup isOpen={(currentAction == 100)} title={t("subscriptions")} onDismiss={() => { setCurrenctAction(0) }} >

                <RolesPage isSelection={true} onItemSelected={(e) => {
                    dispatch(setSelectedRole([e]))
                    setCurrenctAction(0)
                }} onCancel={() => { setCurrenctAction(0) }} />

            </Popup>

            <Popup isOpen={(currentAction == 101)} title={t("clientTypes")} onDismiss={() => { setCurrenctAction(0) }} >

                <UserTypesPage isSelection={true} onItemSelected={(e) => {
                    dispatch(setSelectedUserType([e]))
                    setCurrenctAction(0)
                }} onCancel={() => { setCurrenctAction(0) }} />

            </Popup>

            <Formik

                enableReinitialize={true}
                initialValues={{
                    roles: undefined,
                    userTypes: undefined,
                    body: "",
                    title: "",
                    url: "",
                    from: moment(fromDate, 'YYYY-MM-DD').startOf('day').toDate(),
                    to: moment(new Date(), 'YYYY-MM-DD').endOf('day').toDate(),
                    setIdentityConformationExpiration: false,
                    identityConformationExpiration: moment(new Date(), 'YYYY-MM-DD').endOf('day').toDate(),
                    confirmationStatus: -1,
                    isActive: 0,
                    isProtected: 0,
                    isConfirmed: false

                }}

                validationSchema={Yup.object({
                    body: inputs.note,
                    title: inputs.note,
                    url: inputs.urlandpath,

                })}

                onSubmit={(values, actions) => {
                    if (selectedKey == 0 && props?.renderObject?.client == undefined) {


                        onNextClick();
                        return;
                    }

                    if (props.type == FormType.ADD) {
                        let role = state.roles.selected.at(0);
                        if (role) {
                            const wrapper = new Int32Value();
                            wrapper.setValue(role.id)
                            req.setRole(wrapper);
                        }
                        let userType = state.userTypes.selected.at(0);
                        if (userType) {
                            const wrapper = new Int32Value();
                            wrapper.setValue(userType.id)
                            req.setUsertype(wrapper);
                        }
                        req.setBody(values.body?.trim() ?? "");
                        req.setTitle(values.title?.trim() ?? "");
                        req.setUrl(values.url?.trim() ?? "");


                        if (values.from) {
                            const wrapper = new Timestamp();
                            wrapper.fromDate(moment(values.from, 'YYYY-MM-DD').startOf('day').toDate())
                            req.setFrom(wrapper)
                        }
                        if (values.to) {
                            const wrapperTo = new Timestamp();
                            wrapperTo.fromDate(moment(values.to, 'YYYY-MM-DD').endOf('day').toDate())
                            req.setTo(wrapperTo)
                        }
                        if (values.setIdentityConformationExpiration && values.identityConformationExpiration) {
                            const wrapperTo = new Timestamp();
                            wrapperTo.fromDate(moment(values.identityConformationExpiration, 'YYYY-MM-DD').endOf('day').toDate())
                            req.setTo(wrapperTo)
                        }


                        if (values.confirmationStatus != -1) {
                            const wrapperTo = new Int32Value();
                            wrapperTo.setValue(values.confirmationStatus)
                            req.setIdentityconformationstate(wrapperTo)
                        }

                        if (values.isActive != 0) {
                            const wrapperTo = new BoolValue();
                            wrapperTo.setValue(values.isActive == 1 ? true : false)
                            req.setIsactive(wrapperTo)
                        }
                        if (values.isProtected != 0) {
                            const wrapperTo = new BoolValue();
                            wrapperTo.setValue(values.isProtected == 1 ? true : false)
                            req.setIsprotected(wrapperTo)
                        }

                        if (props?.renderObject?.client == undefined) {
                            req.setIsdirectexecute(values.isConfirmed)
                        } else {
                            req.setIsdirectexecute(true)

                        }


                        promise = dispatch(add({ body: req, headers: getHeaders() }))
                        values.isConfirmed = false;
                        promise.unwrap()
                            .then((res: NotifyResponse.AsObject) => {
                                if (res) {

                                    if (req.getIsdirectexecute()) {
                                        dispatch(resetRoles())
                                        dispatch(resetUserTypes())
                                        actions.resetForm()
                                        onBackClick();


                                    } else {

                                        setShowConfirmation({
                                            type: DialogType.normal,
                                            title: t("confirm"),
                                            subText: t("notifyCount", { count: res.success?.count?.value ?? 0 }),

                                        })
                                        toggleHideDialog()

                                    }

                                }
                                actions.setSubmitting(false)


                            })
                            .catch((error: ApiMessage) => {
                                actions.setSubmitting(false)
                            })
                    } else {

                    }
                }}

            >
                {formkikProps => (
                    <Form onSubmit={(e) => {
                        e.preventDefault()
                        if (props.type == FormType.ADD && props?.renderObject?.client == undefined) {
                            formkikProps.validateForm().then(e => {
                                if (selectedKey == 0)
                                    onNextClick();
                                else formkikProps.submitForm();

                            });
                        } else {
                            formkikProps.submitForm();
                        }
                    }
                    }>
                        <Dialog
                            hidden={hideDialog}
                            onDismiss={toggleHideDialog}
                            dialogContentProps={showConfirmation}
                            modalProps={modalProps}
                        >

                            <DialogFooter>
                                <PrimaryButton autoFocus onClick={(e: any) => { formkikProps.setFieldValue("isConfirmed", true); formkikProps.handleSubmit(e); toggleHideDialog() }} text={t("send")} type="submit" />
                                <DefaultButton onClick={toggleHideDialog} text={t("back")} />
                            </DialogFooter>
                        </Dialog>
                        <Stack tokens={{ childrenGap: props.childrenGap, maxWidth: props.maxWidth, padding: props.padding, maxHeight: props.maxHeight }}    >
                            {state.message != undefined ? (state.message.data != 401) ? <Message
                                body={state.message.body}
                                title={state.message.title}
                                data={state.message.data}
                                onDismiss={() => { dispatch(dismissMessage()) }}
                                type={state.message.type}
                            /> :
                                <SessionExpiredDialog />
                                : null
                            }

                            <Pivot selectedKey={String(selectedKey)} >
                                <PivotItem headerText={t("notificationInfo")} itemKey="0" >
                                    <Stack tokens={{ childrenGap: props.childrenGap, maxWidth: props.maxWidth, padding: props.padding, maxHeight: props.maxHeight }}    >

                                        {props?.renderObject?.client ? <Stack>
                                            <Label required
                                            >{t("to")}</Label>
                                            <List
                                                isPeoplePicker={true}
                                                disabled={true}
                                                suggestionsHeaderText={t('clients')}

                                                inputProps={{ placeholder: t("owntoer") }}
                                                selectedItems={[{ key: props?.renderObject?.client?.internalId, text: props?.renderObject?.client?.name, secondaryText: props?.renderObject?.client?.username, imageUrl: props?.renderObject?.client?.imageSource && props?.renderObject?.client?.imagePath ? props?.renderObject?.client?.imageSource + "" + props?.renderObject?.client?.imagePath : undefined } as IPersonaProps]}

                                                endButtons={[
                                                    {
                                                        title: t("advancedOptions"), checked: true, iconProps: { iconName: "ShowResults" },
                                                        onClick: () => {
                                                        }
                                                    }
                                                ]}
                                                onFilterChanged={(filterText: string, selectedItems?: any[] | undefined) => {
                                                    return [];
                                                }} />

                                        </Stack> : undefined}
                                        <Field name="title" label={t("title")} placeholder={t("title")} component={InputField} required disabled={state.isLoading} maxLength={140} />

                                        <Field name="body" label={t("body")} placeholder={t("body")} component={InputField} rows={3} multiline resizable={false} disabled={state.isLoading} maxLength={140} />

                                        <Field name="url" label={
                                            <div>
                                                {t("notificationURL") + ' '}
                                                <TooltipHost content={t("notificationURLDesc")}>
                                                    <Icon iconName="Info" aria-label={t("notificationURL")} />
                                                </TooltipHost>
                                            </div>
                                        } placeholder={"https://sanadapp.ly"} component={InputField} disabled={state.isLoading} maxLength={2048} />
                                    </Stack>
                                </PivotItem>
                                {props?.renderObject?.client ? undefined : <PivotItem headerText={t("filter")} itemKey="1">

                                    <Stack tokens={{ childrenGap: props.childrenGap, maxWidth: props.maxWidth, padding: props.padding, maxHeight: props.maxHeight }}    >


                                        <DatePicker
                                            isRequired
                                            firstDayOfWeek={DayOfWeek.Sunday}
                                            label={t("createdDate") + " " + t("from")}
                                            placeholder={t("createdDate") + " " + t("from")}
                                            disabled={state.isLoading}
                                            value={formkikProps.values.from}
                                            ariaLabel={t("createdDate") + " " + t("from")}
                                            formatDate={(e) => {
                                                return formatDate(e, 'YYYY-MM-DD')
                                            }}
                                            parseDateFromString={(date) => {
                                                return moment(date, 'YYYY-MM-DD').startOf('day').toDate();
                                            }}
                                            // DatePicker uses English strings by default. For localized apps, you must override this prop.
                                            strings={defaultDatePickerStrings}
                                            onSelectDate={(date: Date | null | undefined) => {

                                                formkikProps.setFieldValue("from", date)
                                            }}

                                        />

                                        <DatePicker
                                            isRequired
                                            firstDayOfWeek={DayOfWeek.Sunday}
                                            label={t("createdDate") + " " + t("to")}
                                            placeholder={t("createdDate") + " " + t("to")}
                                            disabled={state.isLoading}
                                            value={formkikProps.values.to}
                                            ariaLabel={t("createdDate") + " " + t("to")}
                                            formatDate={(e) => {
                                                return formatDate(e, 'YYYY-MM-DD')
                                            }}
                                            parseDateFromString={(date) => {
                                                return moment(date, 'YYYY-MM-DD').endOf('day').toDate();
                                            }}
                                            // DatePicker uses English strings by default. For localized apps, you must override this prop.
                                            strings={defaultDatePickerStrings}
                                            onSelectDate={(date: Date | null | undefined) => {
                                                if (date != undefined)
                                                    if (moment(date).isSameOrAfter(formkikProps.values.from)) {
                                                        formkikProps.setFieldValue("to", date)
                                                    } else {
                                                        formkikProps.setFieldValue("to", new Date())
                                                    }
                                            }}

                                        />
                                        {props.type == FormType.ADD ? <Stack>
                                            <Label
                                                disabled={state.isLoading}>{t("clientType")}</Label>
                                            <List
                                                inputProps={{ placeholder: t("clientType"), }}
                                                disabled={state.isLoading}
                                                suggestionsHeaderText={t('clientTypes')}
                                                isLoading={state.userTypes.items.length == 0 ? state.userTypes.isFetching : false}
                                                isSearching={state.userTypes.items.length > 0 ? state.userTypes.isFetching : false}
                                                moreSuggestionsAvailable={state.userTypes.hasMore && !state.userTypes.isFetching}
                                                suggestions={state.userTypes.items.length > 0 ? state.userTypes.items.map(e => { return { item: { name: e.name, key: e.id } } as ISuggestionModel<ITag> }) : []}
                                                onGetMoreResults={() => {
                                                    if (state.userTypes.items.length > 0 && !state.userTypes.isFetching) {
                                                        userTypeReq.setNextto(state.userTypes.items.at(state.userTypes.items.length - 1).id)
                                                        getFilterPromise = dispatch(getUserTypes({ body: userTypeReq, headers: getHeaders() }))
                                                    }
                                                }}
                                                onSuggestionClick={(ev?, item?: any, index?: number) => {
                                                    var u = state.userTypes.items.findIndex(e => e.id == item.key)
                                                    if (u >= 0) {
                                                        dispatch(setSelectedUserType([state.userTypes.items.at(u)]))

                                                    }
                                                }}
                                                isPeoplePicker={false}
                                                selectedItems={state.userTypes.selected.length > 0 ? state.userTypes.selected.map(e => { return { name: e.name, key: e.id } as ITag }) : []}
                                                onChange={(e) => {
                                                    dispatch(setSelectedUserType([]))

                                                }}
                                                onEmptyInputFocus={() => {
                                                    dispatch(resetUserTypes())
                                                    userTypeReq.setNextto(0)
                                                    dispatch(setIsFilteredUserTypesSet(false))
                                                    getFilterPromise?.abort()
                                                    getFilterPromise = dispatch(getUserTypes({ body: userTypeReq, headers: getHeaders() }))
                                                    return []
                                                }}
                                                onFilterChanged={onUserTypeFilterChanged}
                                                endButtons={[
                                                    {
                                                        title: t("advancedOptions"), checked: true, iconProps: { iconName: "ShowResults" },
                                                        onClick: () => {
                                                            setCurrenctAction(101)

                                                        }
                                                    }]}
                                            />

                                        </Stack> : undefined}

                                        <Stack>
                                            <Label
                                                disabled={state.isLoading}>{t("subscription")}</Label>
                                            <List
                                                inputProps={{ placeholder: t("subscription"), }}
                                                disabled={state.isLoading}
                                                suggestionsHeaderText={t('subscriptions')}
                                                isLoading={state.roles.items.length == 0 ? state.roles.isFetching : false}
                                                isSearching={state.roles.items.length > 0 ? state.roles.isFetching : false}
                                                moreSuggestionsAvailable={state.roles.hasMore && !state.roles.isFetching}
                                                suggestions={state.roles.items.length > 0 ? state.roles.items.map(e => { return { item: { name: e.name, key: e.id } } as ISuggestionModel<ITag> }) : []}
                                                onGetMoreResults={() => {
                                                    if (state.roles.items.length > 0 && !state.roles.isFetching) {
                                                        roleReq.setNextto(state.roles.items.at(state.roles.items.length - 1).id)
                                                        getFilterPromise = dispatch(getRoles({ body: roleReq, headers: getHeaders() }))
                                                    }
                                                }}
                                                onSuggestionClick={(ev?, item?: any, index?: number) => {
                                                    var u = state.roles.items.findIndex(e => e.id == item.key)
                                                    if (u >= 0) {
                                                        dispatch(setSelectedRole([state.roles.items.at(u)]))
                                                    }
                                                }}
                                                isPeoplePicker={false}
                                                selectedItems={state.roles.selected.length > 0 ? state.roles.selected.map(e => { return { name: e.name, key: e.id } as ITag }) : []}
                                                onChange={(e) => {
                                                    dispatch(setSelectedRole([]))

                                                }}
                                                onEmptyInputFocus={() => {
                                                    dispatch(resetRoles())
                                                    roleReq.setNextto(0)
                                                    dispatch(setIsFilteredRolesSet(false))
                                                    getFilterPromise?.abort()
                                                    getFilterPromise = dispatch(getRoles({ body: roleReq, headers: getHeaders() }))
                                                    return []
                                                }}
                                                onFilterChanged={onRoleFilterChanged}
                                                endButtons={[
                                                    {
                                                        title: t("advancedOptions"), checked: true, iconProps: { iconName: "ShowResults" },
                                                        onClick: () => {
                                                            setCurrenctAction(100)

                                                        }
                                                    }]}
                                            />

                                        </Stack>




                                        <Toggle
                                            onText={t("enabled")} offText={t("disabled")}
                                            label={t("confirmationExpirationDate")}
                                            disabled={state.isLoading}

                                            checked={formkikProps.values.setIdentityConformationExpiration}
                                            onChange={(ev: React.MouseEvent<HTMLElement>, checked?: boolean) => {
                                                formkikProps.setFieldValue("setIdentityConformationExpiration", checked);

                                            }
                                            }
                                        />
                                        {formkikProps.values.setIdentityConformationExpiration ?
                                            <DatePicker
                                                firstDayOfWeek={DayOfWeek.Sunday}
                                                placeholder={t("confirmationExpirationDate")}

                                                disabled={state.isLoading}
                                                value={formkikProps.values.identityConformationExpiration}
                                                ariaLabel={t("confirmationExpirationDate")}
                                                formatDate={(e) => {
                                                    return formatDate(e, 'YYYY-MM-DD')
                                                }}
                                                parseDateFromString={(date) => {
                                                    return moment(date, 'YYYY-MM-DD').startOf('day').toDate();
                                                }}
                                                // DatePicker uses English strings by default. For localized apps, you must override this prop.
                                                strings={defaultDatePickerStrings}
                                                onSelectDate={(date: Date | null | undefined) => {
                                                    if (date != undefined)
                                                        formkikProps.setFieldValue("identityConformationExpiration", date)

                                                }}

                                            /> : undefined}

                                        <ComboBox
                                            label={t("accountStatus")}
                                            selectedKey={formkikProps.values?.isActive}
                                            allowFreeInput={false}
                                            allowFreeform={false}
                                            disabled={state.isLoading}

                                            options={[{ key: 0, text: t("activeAndInactive") }, { key: 1, text: t("active") }, { key: 2, text: t("inactive") }]}
                                            onChange={(e, o) => {

                                                formkikProps.setFieldValue(`isActive`, o?.key)

                                            }}
                                        />

                                        <ComboBox
                                            label={t("identityConfirm")}
                                            allowFreeInput={false}
                                            allowFreeform={false}
                                            disabled={state.isLoading}

                                            selectedKey={formkikProps.values.confirmationStatus}
                                            options={[{ key: -1, text: t("confirmedAndUnconfirmed") }, { key: IdentityConformationState.NOT_CONFIRMED, text: t("unconfirmed") }, { key: IdentityConformationState.INFO_INVALID, text: t("invalidInfo") }, { key: IdentityConformationState.UPDATE_REQURED, text: t("updateRequired") }, { key: IdentityConformationState.PENDING_CONFIRMATION, text: t("confirmationPending") }, { key: IdentityConformationState.UPDATE_UNDER_REVIEW, text: t("inReview") }, { key: IdentityConformationState.CONFIRMED, text: t("confirmed") }]}
                                            onChange={(e, o) => {
                                                formkikProps.setFieldValue(`confirmationStatus`, o?.key)

                                            }}
                                        />



                                        <ComboBox
                                            label={t("protection")}
                                            allowFreeInput={false}
                                            allowFreeform={false}
                                            disabled={state.isLoading}

                                            selectedKey={formkikProps.values.isProtected}
                                            options={[{ key: 0, text: t("enabledAndDisabled") }, { key: 1, text: t("enabled") }, { key: 2, text: t("disabled") }]}
                                            onChange={(e, o) => {
                                                formkikProps.setFieldValue(`confirmationStatus`, o?.key)

                                            }}
                                        />




                                    </Stack>




                                </PivotItem>}


                            </Pivot>





                        </Stack>
                        <DialogFooter>
                            <PrimaryButton type="submit" disabled={state.isLoading} text={state.isLoading ? undefined : props?.renderObject?.client ? t("send") : selectedKey == 0 ? t("next") : props.type == FormType.ADD ? t("confirm") : t("edit")} >

                                <Spinner size={SpinnerSize.medium} styles={{ root: { display: (state.isLoading ? "block" : "none") } }} />

                            </PrimaryButton>
                            <DefaultButton disabled={state.isLoading} text={selectedKey == 1 ? t("back") : props.type == FormType.ADD ? t("discard") : t("cancel")} onClick={() => {
                                if (selectedKey == 1) {
                                    onBackClick();
                                    return;
                                }
                                if (props.onCancel) {


                                    formkikProps.resetForm()
                                    props.onCancel()
                                }
                            }} />
                        </DialogFooter>



                    </Form>
                )}
            </Formik >
        </>
    );

}

